export default "__VITE_ASSET__DNZiuuRJ__"